export const QA_NAME_FOLDER_CREATION_MODAL = 'create_folder'
